import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import { Grid, MenuItem, Select } from "@material-ui/core";
import useForm from "../lib/useForm";
import { useSnackbar } from "notistack";
import config from "../../../config";
import ThingsContext from "../../PublicLayout/thingsContext";
import { saveWebResult } from "../lib/sync/questionsLib";


const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(0),
  },
  center: {
    textAlign: "center",
  },
  edit: {
    backgroundColor: "#e8e8e8",
  },
}));

const defaultValues = () => {
  return {
    question: "",
    Qtype: "Match Column",
    col: {
      1: "",
      2: "",
      3: "",
      4: "",
      5: "",
      6: "",
    },
    match: {
      1: "",
      2: "",
      3: "",
      4: "",
      5: "",
      6: "",
    },
    "image-col": {
      1: "",
      2: "",
      3: "",
      4: "",
      5: "",
      6: "",
    },
    "image-match": {
      1: "",
      2: "",
      3: "",
      4: "",
      5: "",
      6: "",
    },
  };
};

export default function FullScreenDialog({ item, fetchNew }) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [values, , resetForm] = useForm(defaultValues);
  const [block, setBlock] = useState(false);
  const [things] = useContext(ThingsContext);
  const [questions_id, setQuestionId] = useState(0);

  useEffect(() => {
    if (block) return;
    setBlock(true);
    if (item) {
      resetForm(item.question);
      setQuestionId(item.questions_id);
    }
  }, [block, item, resetForm]);

  const register = (e) => {
    e.preventDefault();
    saveObject(values);
    // if (!editId) restObject();
  };

  const saveObject = (question) => {
    let obj = {
      school_id: things[0],
      section_id: things[2],
      student_id: things[5],
      question_attempts: 1,
      question_id: JSON.stringify([
        { attempted: true, question_id: questions_id },
      ]),
      question_count: 5,
      is_from_video: 0,
    };

    saveWebResult(obj)
      .then((res) => {
        console.log("res", res);
        fetchNew();
        enqueueSnackbar(`Question Answer Added Successfully.`);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  return (
    <form onSubmit={register}>
      <hr />
      <br />
      <Grid container spacing={2}>
        <Grid item xs={8} style={{ display: "flex", justifyContent: "flex-start" }}>
          <h3>{values.question}</h3>
        </Grid>
        <Grid item xs={4}>
          {values.questionImage && (
            <img
              className={classes.image}
              src={config.imageCDN + values.questionImage}
              title={values.questionImage.split("/").pop()}
              alt={values.questionImage.split("/").pop()}
              width={100}
            />
          )}
        </Grid>
      </Grid>
      <br />

      <Grid container spacing={2}>
        {[1, 2, 3, 4, 5, 6].map((x) => {
          return (
            values.col[x] && (
              <React.Fragment key={x}>
                <Grid item xs={3}>
                  <FormControl
                    fullWidth
                    className={classes.margin}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-amount">
                      {values.col ? values.col[x] : ""}
                    </InputLabel>
                  </FormControl>
                </Grid>
                <Grid
                  container
                  alignItems="center"
                  justifyContent="center"
                  item
                  xs={2}
                >
                  {values["image-col"][x] && (
                    <img
                      className={classes.image}
                      src={config.imageCDN + values["image-col"][x]}
                      alt={values["image-col"][x].split("/").pop()}
                      width={100}
                    />
                  )}
                </Grid>
                <Grid item xs={3}>
                  <FormControl className={classes.formControl}>
                    <InputLabel id="demo-simple-select-label">
                      Column
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={1}
                      onChange={() => {
                        console.log("handleChange");
                      }}
                    >
                      <MenuItem value={1}>1</MenuItem>
                      <MenuItem value={2}>2</MenuItem>
                      <MenuItem value={3}>3</MenuItem>
                      <MenuItem value={4}>4</MenuItem>
                      <MenuItem value={5}>5</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  container
                  alignItems="center"
                  justifyContent="center"
                  item
                  xs={2}
                >
                  {values["image-match"][x] && (
                    <img
                      className={classes.image}
                      src={config.imageCDN + values["image-match"][x]}
                      alt={values["image-match"][x].split("/").pop()}
                      width={100}
                    />
                  )}
                </Grid>
              </React.Fragment>
            )
          );
        })}
      </Grid>

      <Grid
        item
        xs={12}
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Button variant="contained" color="primary" type="submit">
          Submit
        </Button>
      </Grid>
    </form>
  );
}
